import { observer } from "mobx-react-lite";

import { IconDownload, IconLoader } from "@synthesis/shared-icons";
import { Button, Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

import { useStores } from "../../store";

type DownloadButtonProps = {
  disabled?: boolean;
  onClick?: () => void | Promise<void>;
};

const DownloadButton = observer(({ disabled, onClick }: DownloadButtonProps) => {
  const { fileStore } = useStores();
  const isDownloading = fileStore.isDownloading;
  const isDisabled = disabled || isDownloading;

  const handleClick = () => {
    if (isDisabled || !onClick) return;
    void onClick();
  };

  return (
    <Tooltip description="Скачать" arrowSide="bottom">
      <span className={cn("inline-flex", isDownloading && "cursor-not-allowed")} aria-label="Скачать">
        <Button
          size="sm"
          theme="text"
          className={isDownloading ? "cursor-not-allowed" : undefined}
          disabled={isDisabled}
          leftIcon={isDownloading ? <IconLoader className="size-5 animate-spin" aria-hidden /> : <IconDownload className="size-5" />}
          onClick={handleClick}
        />
      </span>
    </Tooltip>
  );
});

export default DownloadButton;
